export const dailyMessages = [
  '내가 만드는 하루,<br>나의 에너지는?',
  '행복을 여는<br>오늘의 조각은?',
  '오늘의 흐름을<br>읽어보세요',
  '당신의 하루,<br>별들이 속삭이는 비밀',
  '오늘이라는<br>책의 첫 페이지',
  '내가 풀어가는 실타래,<br>오늘의 에너지는?',
  '오늘을 설계할<br>특별한 힌트!',
  '당신을 위한<br>하루 에너지 충전소',
  '행운의 문,<br>오늘 당신을 기다립니다',
  '오늘 하루,<br>빛나는 시작을 확인하세요',
  '나를 위한<br>긍정의 하루 비법',
  '오늘을 움직이는<br>운명의 톱니바퀴',
  '당신만의 하루 키워드,<br>지금 찾아보세요',
  '미리 엿보는<br>오늘의 에너지',
  '하루의 방향을<br>알려주는 나침반',
  '당신의 하루,<br>작은 신호를 해석하세요',
  '오늘의 시간,<br>당신만의 리듬은?',
  '당신의 하루,<br>어떤 색으로 칠해질까요?',
  '운명과 하루가<br>교차하는 순간',
  '오늘의 가능성을<br>열어보세요',
  '당신만의 하루 레시피를<br>발견하세요',
  '오늘의 에너지,<br>숨겨진 단서를 찾으세요',
  '행복한 하루를 여는<br>작은 여정',
  '오늘 당신의 선택은?',
  '오늘의 이야기,<br>당신이 주인공입니다.',
  '하루 속 작은 행운을<br>찾아보세요.',
  '오늘의 주인공은<br>당신입니다.',
  '내가 만들어가는<br>소중한 하루',
  '행복을 만들어 가는<br>작은 드라마',
  '내가 쓰는 작은 드라마,<br>오늘',
];

/** 택일 달력 호버 메시지 (문구 추가는 이 배열에 추가하면 됨) */
export const choiceHoverMessages = [
  '어떤 날이 좋을까요?',
  // 카테고리 공통
  '그냥 넘어가기엔 찜찜해요~',
  '마음이 편한 쪽으로',
  '불편한 날은 피하고 싶은데',
  '이유는 모르겠는데<br>신경 쓰이는 날이 있어요.',
  // 계약 · 문서
  '사인 전, 날짜 체크',
  '조건 말고 시기가 걸릴 때',
  '그냥 넘어가기엔 찜찜',
  '한 번 더 확인하는 날짜',
  // 이사 · 입주
  '이사 날짜, 신경 쓰여요',
  '몸이 먼저 반응하는 날',
  '바꾸긴 어렵지만 보고 싶을 때',
  '찝찝함은 피하고 싶어서',
  // 병 · 검진
  '신경 쓰이는 날<br>마음이 편한 쪽으로',
  '마음부터 다잡고 싶을 때',
  '그냥 지나치기엔 부담인 날에<br>살펴봐요~',
  // 연애 · 고백
  '타이밍이 맞을까?<br>살짝 궁금할 때~',
  '지금 말해도 될까!<br>한 박자 고민되는 날',
  '괜히 망설여지는 타이밍에',
  // 시험 · 오디션
  '컨디션이 중요할 때,<br>긴장되면 날짜부터',
  '괜히 떨리는 날,<br>마음 안정용 체크',
  '운도 한번 체크해보고 싶을 때 …',
  // 금전 · 지출
  '써도 되는 날일까,<br>타이밍이 고민될 때',
  '돈 나가기 전<br>한 번 날짜라도 보고 쓸까?',
  '그냥 넘기기엔 아쉬움',
  '날짜라도 보고 쓰자',
  // 여행 · 출장
  '내 에너지에 맞는 컨디션으로<br>일정잡기~',
  '무난한 날, 일정잡고 싶을 때',
  // 개업 · 시작
  '시작 날짜, 한 번 더',
  '괜히 의미 두고 싶을 때',
  '덜 불안한 쪽으로<br>날짜 보고 싶을 때',
  '마음 편한 시작,<br>무난한 일정 잡기~',
  // 라이트 택일용 짧은 문안
  '오늘을 위한 작은 힌트',
  '지금 필요한 하루의 방향',
  '오늘의 선택 포인트',
  '오늘의 기운 한 스푼',
  '오늘, 어떤 날일까요?',
  // 감성형
  '오늘이라는 하루를<br>천천히 열어봅니다',
  '당신의 하루가 시작되는 지점',
  '오늘의 시간에 귀 기울여 보세요',
  '하루가 건네는 작은 신호',
  '오늘의 공기가 말해주는 이야기',
  '오늘의 흐름 속으로 한 걸음',
  '하루의 문턱에서 만나는 메시지',
  '오늘을 부드럽게 시작하는 방법',
  '오늘의 하루,<br>어떻게 흘러갈까요',
  '오늘의 장면을 미리 들여다보세요',
  // 선택 · 결정 중심
  '오늘의 선택,<br>가볍게 점검해보세요',
  '결정 전에 한 번 더 살펴보세요',
  '오늘 고르기 좋은 방향은?',
  '지금 결정해도 괜찮을까요?',
  '오늘의 선택 포인트를 확인하세요',
  '오늘은 어떤 선택이 어울릴까요',
  '방향이 필요한 순간입니다',
  '오늘의 흐름에 맞는 선택',
  '오늘, 결정의 타이밍은?',
  '오늘의 판단 기준 한 줄',
  // 행운 · 기회 · 타이밍
  '오늘의 행운 포인트를 확인하세요',
  '기회가 스치는 순간을 살펴보세요',
  '오늘의 타이밍, 열려 있을까요',
  '행운의 흐름이 보이는 하루',
  '오늘의 기운이 돕는 방향',
  '오늘의 가능성 체크',
  '오늘은 기회를 살펴볼 날',
  '흐름이 열리는 순간',
  '오늘의 행운 신호',
  '기운이 따라주는 하루일까요',
  // 변주형
  '오늘의 흐름, 당신의 선택은?',
  '오늘의 에너지,<br>어디로 향할까요',
  '하루의 방향을 미리 읽어보세요',
  '오늘의 이야기, 지금 확인하세요',
  '당신의 하루에 필요한 한 줄',
  '오늘을 설계하는 작은 힌트',
  '오늘의 리듬을 맞춰보세요',
  '하루의 흐름을 가볍게 확인',
  '오늘의 기운이 알려주는 방향',
  '당신만의 오늘을 준비해보세요',
];
